// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fRXsi","title":"styles_title__16mbH"};